import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import { GoogleAdsLocationGq, GoogleAdsLocationGqProps } from '../../models/GoogleAdsLocationGq';
import { QueryHookOptions } from '@apollo/client';

export default function useGetGoogleAdsLocationsGq(
  command: GetGoogleAdsLocationsCommand,
  options?: QueryHookOptions<ResponseGq, VariablesGq>
) {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-first',
    ...options,
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getGoogleAdsLocations?.adwordsLocations,
  };
}

const gqTag = gql`
  query GetGoogleAdsLocations($command: GetGoogleAdsLocationsCommand!) {
    projects {
      getGoogleAdsLocations(command: $command) {
        adwordsLocations {
            ${GoogleAdsLocationGqProps}
        }
      }
    }
}`;

interface VariablesGq {
  command: GetGoogleAdsLocationsCommand;
}

export interface GetGoogleAdsLocationsCommand {
  id?: number;
  targetType?: string;
  excludeTargetType?: string;
  countryCode?: string;
  searchTerm?: string;
  limitItems?: number;
}

interface ResponseGq {
  projects: {
    getGoogleAdsLocations: {
      adwordsLocations: GoogleAdsLocationGq[];
    };
  };
}
